/* eslint-disable no-useless-escape */
// taken from https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript
export const EMAIL_PATTERN =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const PHONE_PATTERN = /^[+\d\s/()\-]{8,}$/;

export const POSTAL_CODE_PATTERN = /^\d{5}$/;

export const AUTH_COOKIE = "justhome-auth";

export const PERCENTAGE_PATTERN = /^[0-9]{1,2}([\.,]?[0-9]{1,2})?$/;

export * from "./query-params";
